module.exports = __webpack_public_path__ + "img/yogWarrior365.224dd5c1.jpeg";